
document.addEventListener("DOMContentLoaded", function() {

    $('#accept-public-offer').on('click',function(){
        var uuid = $('#accept-public-offer').data('uuid');
        Do.Ajax("/accept-offer",{
            data: {
                uuid: uuid,
            },
        });
        
    });

});
